<template>
  <div class="subject-list">
    <div v-if="back">
     <div class="detail-header">
          <span class="detail-back" @click="cancelSearch('')"><i class="ri-arrow-left-s-line"></i>返回</span>
          <div class="detail-type"></div>
      </div> 
      <div id="panel">
        
      </div>
    </div>
    <div class="sub-group"
        v-if="list"
         v-for="groupItem in data"
         :key="groupItem.groupCode">
      <div class="sub-group-title">{{ groupItem.groupName }}</div>
      <div class="sub-list clearfix">
        <div class="sub-item"
             v-for="(item, index) in groupItem.children"
             :key="item.code"
             @click="handleSubject(item)">
             <div class="item-image"
               v-if="item.image"
               :style="{ background: formatBg(item.image) }"></div>
          <div class="item-main">
            <div class="item-icon" :class="'icon-bg-' + ((index + 1) % 4)">
              <i :class="item.icon"></i>
            </div>
            <div class="item-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mapUtil from "@/api/mapUtil";
import store from '@/store'
import hallMixins from "@/mixins/hallMixins";
export default {
  name: "SubjectList",
  mixins: [hallMixins],
  data() {
    return {
      back: false,
      list: true
    };
  },
  props: {
    data: {
      type: Array
    }
  },
  methods: {
    cancelSearch() {
      this.back = false;
      this.list = true;
      mapUtil.initMap();
    },
    markerClick(e) {
      infoWindow.setContent(e.target.content);
      infoWindow.open(map, e.target.getPosition());
    },
    handleSubject(item) {
      let url = require("@/assets/images/pin.png");
        this.$emit("selectSubject", item);
        // mapUtil.initMap();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.amap-marker {
  display: none !important;
}
::v-deep{
  .amap-info-content{
    padding: 0 !important;
  }

.map-info{
    position: relative;
    display: flex;
    align-items: center;
    padding: 8px 0;
    background: #fff;
    border: none;
    border-radius: 4px;
    //box-shadow: 0 2px 6px 0 rgba(103, 103, 103, 0.5);
    &:after{
      position: absolute;
      content:"";
      bottom: -7px;
      left: 0;
      right: 0;
      width: 7px;
      margin: 0 auto;
      border-top: 7px #fff solid;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
    }
    .info{
      padding: 0 $paddingHorizontal;
      text-align: center;
      vertical-align: top;
    }
    .icon{
      padding: 0 $paddingHorizontal;
      text-align: center;
      cursor: pointer;
      vertical-align: top;
      border-left: 1px solid $borderColorPrimary;
      i{
        display: block;
        margin: 0 auto;
        width: 24px;
        height: 24px;
        background: url("~@img/map/go.png") center/contain no-repeat;
      }
      span{
        font-size: 12px;
      }
      &:hover{
        color: $colorPrimary;
      }
    }
  }
}
.subject-list {
  .sub-group-title {
    padding: 0 $paddingHorizontal;
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 500;
    color: $colorTextPrimary;
  }
  .sub-list {
    padding: 0 8px;
  }
  .sub-item {
    float: left;
    width: 33.33%;
    padding: 0 -1px;
    margin-bottom: 8px;
    .item-main {
      width: 100%;
      padding: 8px 0;
      transition: $transitionTime;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        color: $colorPrimary;
        background-color: #f5f7f9;
      }
    }
    .item-icon {
      width: 64px;
      height: 64px;
      margin: 0 auto;
      font-size: 22px;
      text-align: center;
      line-height: 56px;
      color: #fff;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      &.icon-bg-1 {
        background-image: url("~@img/subject/subject-bg-purple.png");
      }
      &.icon-bg-2 {
        background-image: url("~@img/subject/subject-bg-green.png");
      }
      &.icon-bg-3 {
        background-image: url("~@img/subject/subject-bg-blue.png");
      }
      &.icon-bg-0 {
        background-image: url("~@img/subject/subject-bg-yellow.png");
      }
    }
    .item-name {
      padding: 0 4px;
      font-size: 12px;
      text-align: center;
    }
  }
}
</style>
